import { BarElement, CategoryScale, Chart as ChartJS, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';

import LoadingCircle from '~components/Loading';
import { ICompanyWorkLife } from '~types/company';

import { useChartProps } from './hooks';
import * as S from './style';

ChartJS.register(ChartDataLabels, CategoryScale, LinearScale, BarElement);

interface Props {
  chartData?: ICompanyWorkLife['overtime'];
  isEmpty?: boolean;
}

export default function BarChart({ chartData, isEmpty }: Props) {
  const chartDataValues = Object.values(chartData ?? {});
  const { data, options } = useChartProps({ chartData: chartDataValues });

  if (!chartData) {
    return <LoadingCircle />;
  }

  return (
    <S.Wrapper>
      <Bar data={data} options={options} />
      {isEmpty && <S.NoData>등록된 리뷰가 없습니다.</S.NoData>}
    </S.Wrapper>
  );
}
